import { useState } from "react";
import { Stack, Text, useBoolean } from "@chakra-ui/react";

import { ContactFormStep1 } from "./ContactFormStep1";
import { ContactFormStep2 } from "./ContactFormStep2";
import { ContactFormStep3 } from "./ContactFormStep3";

export enum Duration {
  one = "1",
  two = "2",
  three = "3",
  four = "4",
  six = "5",
}

export interface ContactFormFields {
  name?: string;
  extras?: string;
  contact?: string;
  queries?: string;
  datetime?: string;
  duration?: Duration;
}

export interface ContactFormStepProps {
  isFinalStep?: boolean;
  setFormStep?: React.Dispatch<React.SetStateAction<number>>;
  setContactFormFields: React.Dispatch<React.SetStateAction<ContactFormFields>>;
  contactFormFields: ContactFormFields;
}

export const ContactForm = () => {
  const [contactFormFields, setContactFormFields] = useState<ContactFormFields>(
    {},
  );

  const [formStep, setFormStep] = useState(1);

  const [isSubmitting, setIsSubmitting] = useBoolean();
  const [errorMessage, setErrorMessage] = useState<string>();

  const onFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitting.on();
    const formData = new FormData(event.currentTarget);
    console.log(formData);

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setFormStep(4);
      setContactFormFields({});
    } else {
      console.log("Error", data);
      if (data.message) {
        setErrorMessage(data.message);
      } else {
        setErrorMessage(
          "Sorry, an error occured. Send me a message using my contact details below.",
        );
      }
    }
    setIsSubmitting.off();
  };

  return (
    <>
      {formStep === 1 && (
        <ContactFormStep1
          setFormStep={setFormStep}
          contactFormFields={contactFormFields}
          setContactFormFields={setContactFormFields}
        />
      )}

      {formStep === 2 && (
        <ContactFormStep2
          setFormStep={setFormStep}
          contactFormFields={contactFormFields}
          setContactFormFields={setContactFormFields}
        />
      )}

      {formStep === 3 && (
        <ContactFormStep3
          setFormStep={setFormStep}
          contactFormFields={contactFormFields}
          setContactFormFields={setContactFormFields}
          onFormSubmit={onFormSubmit}
          errorMessage={errorMessage}
          isSubmitting={isSubmitting}
        />
      )}

      {formStep === 4 && (
        <Stack gap="1">
          <Text color="brand.contrast" opacity="84%">
            Your inquiry has been sent.
          </Text>
          <Text>I'll be in touch in the next couple days.</Text>
        </Stack>
      )}
    </>
  );
};
